'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var loginComponent = exports.loginComponent = {
    template: require('./login.html'),
    controllerAs: 'vm',
    bindings: {
        redirectLocation: '@?',
        tenants: '<?',
        isAdmin: '<',
        isBuyer: '<',
        isSeller: '<',
        selectedSauk: '<?'
    },
    controller: ["common", "gettextCatalog", "authService", function controller(common, gettextCatalog, authService) {
        'ngInject';

        var vm = this;
        vm.select = select;
        vm.selectSeller = selectSeller;
        vm.$onInit = init;
        vm.confirm = confirm;

        vm.selectedTenant = undefined;

        function init() {
            var _this = this;

            common.navigationMenu.setHomeActive();
            common.setTitle(gettextCatalog.getString('Log in'));
            if (this.selectedSauk) {
                this.selectSeller(this.tenants.find(function (x) {
                    return x.secondaryAppUserKey === _this.selectedSauk;
                }));
            }
        }

        function select(tenant) {
            var isSeller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var redirect = vm.redirectLocation;
            if (isSeller && redirect && redirect.indexOf('/nl/' + vm.selectedTenant.sellerId) < 0 && redirect.indexOf('/fr/' + vm.selectedTenant.sellerId)) {
                redirect = '/';
            }
            authService.signIn(redirect, { tenant: tenant }).catch(function () {
                common.log.warn('Signin with tenant failed');
            });
        }

        function selectSeller(tenant) {
            this.selectedTenant = tenant;
        }

        function confirm(buyer) {
            if (this.isBuyer) {
                vm.select(buyer.id);
            } else {
                vm.select(this.selectedTenant.secondaryAppUserKey + ';' + buyer.id, true);
            }
        }
    }]
};


//////////////////
// WEBPACK FOOTER
// ./features/layout/login.js
// module id = 940
// module chunks = 0